import { ThreadDraft } from 'types/savings';

export const validateThreadDraft = (draft: ThreadDraft) => !!draft.name && draft.opportunities.length > 0;
